<template>
  <FormKit type="select" label="Transferred" v-model="modelValue" :options="yesNo" />
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
import { yesNo as yesNoList } from '~/lib/enums/yes-no';
const props = defineProps<{
  modelValue: string;
}>();
const yesNo = ref([{ value: '', label: '' }].concat(yesNoList));
const emit = defineEmits(['update:modelValue']);
const { modelValue } = useVModels(props, emit);
</script>
